import { createApiSlice } from "@common";
import {
  CURD_SALES_TEAM
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addSalesTeam",
    method: "post",
    url: CURD_SALES_TEAM,
    stateKey: "message",
  },
  {
    name: "getSalesTeam",
    method: "get",
    url: CURD_SALES_TEAM,
    stateKey: "data",
  },
  {
    name: "updateSalesTeam",
    method: "put",
    url: CURD_SALES_TEAM,
    stateKey: "message",
  },
  {
    name: "deleteSalesTeam",
    method: "delete",
    url: CURD_SALES_TEAM,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "salesTeam",
  apiConfig,
  customReducers,
);
const salesTeamSlice = slice;
// Export the slice's reducer
export default salesTeamSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addSalesTeam,
  getSalesTeam,
  updateSalesTeam,
  deleteSalesTeam
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
